import { AxiosRequestConfig } from 'axios';
import { AuthResult } from './AuthService';
import { get as httpGet, post as httpPost, del as httpDelete, patch as httpPatch } from './HttpService';
import { getItem } from './LocalStorageService';

const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
export const apiUrl = isDev ? 'http://localhost:8083' : '';
export const baseURL = `${apiUrl}/api/v1`;
const zendeskTicketIdHeader = 'X-ZENDESK-TICKET-ID';
export const CHARGEBEE_URL = 'https://prerender.chargebee.com';

const defaultConfig: AxiosRequestConfig = {
  baseURL,
  headers: {
    'content-type': 'application/json',
  },
  timeout: 0,
};

export const LoginResponseLocalStorageKey = 'LoginResponse';
export const setAuthHeaderToDefaultHeader = () => {
  const authResult: AuthResult | null = getItem(LoginResponseLocalStorageKey);
  if (authResult) {
    defaultConfig.headers!['Authorization'] = `${authResult.token}`;
  }
};
export const setZendeskTicketIdToDefaultHeader = (zendeskTicketId: number | undefined) => {
  if (!zendeskTicketId) {
    delete defaultConfig.headers![zendeskTicketIdHeader];
  } else {
    defaultConfig.headers![zendeskTicketIdHeader] = `${zendeskTicketId}`;
  }
};

setAuthHeaderToDefaultHeader();

export const get = async <T>(path: string): Promise<T> => {
  return httpGet<T>(path, defaultConfig);
};

export const post = async <T>(path: string, body: any): Promise<T> => {
  return httpPost<T>(path, body, defaultConfig);
};

export const postFormData = async <T>(path: string, formData: FormData): Promise<T> => {
  const headers = { ...defaultConfig.headers };
  delete headers['content-type'];
  const config: AxiosRequestConfig = { ...defaultConfig, headers };

  return httpPost<T>(path, formData, config);
};

export const del = async <T>(path: string): Promise<T> => {
  return httpDelete<T>(path, defaultConfig);
};

export const patch = async <T>(path: string, body: any): Promise<T> => {
  return httpPatch<T>(path, body, defaultConfig);
};
